import React from 'react';
import './App.css';
import Game from './containers/Game/Game';
import SidePanel from './containers/SidePanel/SidePanel';
import TopBar from './containers/TopBar/TopBar';
import SettingsPanel from './containers/SettingsPanel/SettingsPanel';

class App extends React.Component {
  constructor(props) {
    super(props);
    let initSize = localStorage.getItem("lastSize");
    if (!initSize) initSize = 5;
    this.state = { width: 0, height: 0, size: initSize, forceUpdate: 0, showSettings: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  handleSizeChange = (size) => {
    localStorage.setItem("lastSize", size);
    this.setState({ size: size , showSettings: false});
  }

  handleOnGameDone = () => {
    this.setState({ forceUpdate: Math.random() })
  }

  handleOpenSettings = () => {
    this.setState((prevState) => {return {showSettings: !prevState.showSettings}})
  }

  render() {


    return (
      <div className="App">
        {
          this.state.width > 600 ?
            <>
              {this.state.height > 750 ?
                <div className="label-container">
                  <p className="label">Schulte Table</p>
                  <p className="secondary-label">Improve fast reading & attention</p>
                </div> : null
              }
              <SidePanel size={this.state.size} sizeChanged={this.handleSizeChange} key={this.state.forceUpdate} />
            </>
            : 
            <>
              <TopBar openSettings={this.handleOpenSettings} showed={this.state.showSettings}/>
              <SettingsPanel size={this.state.size} sizeChanged={this.handleSizeChange} show={this.state.showSettings}/>
            </>
        }
        <Game size={this.state.size} width={this.state.width} onGameDone={this.handleOnGameDone} />
        
      </div>
    );
  }


}

export default App;
